import { Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { Fixed2 } from '../../../../common/utils/common.utils';
import { ITotal_Due_Advance_ClientDataType } from '../types/Total_Due_Advance_ClientTypes';
import { Link } from 'react-router-dom';

const { Text } = Typography;
export const Total_Due_Advance_ClientUtils = (pagination: {
  current: number;
  pageSize: number;
}): ColumnsType<ITotal_Due_Advance_ClientDataType> => {
  return [
    {
      title: 'SL.',
      render: (_, data, index) => (
        <>
          {((pagination.current || 1) - 1) * (pagination.pageSize || 20) +
            1 +
            index}
        </>
      ),
    },
    {
      title: 'Client Name',
      dataIndex: 'client_name',
      key: 'client_name',
      render: (value, record, index) => (
        <Link to={`/clients/details/client-${record.client_id}`}>
          {record.client_name}
        </Link>
      ),
    },

    {
      title: 'Mobile No.',
      dataIndex: 'mobile',
      key: 'mobile',
      render: (_, record) =>
        record.client_mobile ? record.client_mobile : 'N/A',
    },
    {
      title: 'Email No.',
      dataIndex: 'email',
      key: 'email',
      render: (_, record) =>
        record.client_email ? record.client_email : 'N/A',
    },
    {
      title: 'Present Due',
      dataIndex: 'ctrxn_lbalance',
      key: 'ctrxn_lbalance',
      align: 'right',
      render: (_, record) => {
        return (
          <Text type='danger'>
            {Number(record.ctrxn_lbalance) < 0
              ? Fixed2(Math.abs(Number(record.ctrxn_lbalance)))
              : '00'}
          </Text>
        );
      },
    },
    {
      title: 'Present Advance',
      dataIndex: 'ctrxn_lbalance',
      key: 'ctrxn_lbalance',
      align: 'right',
      render: (_, record) => {
        return (
          <Text type='success'>
            {Number(record.ctrxn_lbalance) > 0
              ? Number(record.ctrxn_lbalance)
              : '00'}
          </Text>
        );
      },
    },
    {
      title: 'Last Balance',
      dataIndex: 'client_lbalance',
      key: 'client_lbalance',
      align: 'center',
      render: (amount) => {
        return (
          <Text
            style={{
              color:
                Number(amount) === 0
                  ? '#18b4e9'
                  : Number(amount) > 0
                  ? 'green'
                  : 'red',
            }}
          >
            {Fixed2(Math.abs(Number(amount)))}
          </Text>
        );
      },
    },
    {
      title: 'Credit Limit',
      dataIndex: 'client_credit_limit',
      key: 'client_credit_limit',
      align: 'center',
      render: (_, record) =>
        record.client_credit_limit ? record.client_credit_limit : 'N/A',
    },
  ];
};
